import { render } from "./AgeVerificationDialog.vue?vue&type=template&id=ba7df250"
import script from "./AgeVerificationDialog.vue?vue&type=script&lang=js"
export * from "./AgeVerificationDialog.vue?vue&type=script&lang=js"

import "./AgeVerificationDialog.vue?vue&type=style&index=0&id=ba7df250&lang=scss"
script.render = render

export default script